import React from 'react';
import teachingImage from '../assets/teaching.webp';

const Teaching = () => {
  return (
    <section
      id="teaching"
      className="py-16 px-8 lg:px-32"
      style={{ 
        fontFamily: "'EB Garamond', serif", 
        backgroundColor: '#f7f6ef',
        color: '#1a1a1a'
      }}
    >
      <div className="container mx-auto">
        <h2 className="text-3xl font-medium text-center mb-8">
          TEACHING
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column */}
          <div>
            <p className="text-base sm:text-lg md:text-xl leading-loose">
            I enjoy teaching piano and violin at local schools in the Surrey area, which I have done for many years. I teach all age groups from beginners to advanced, and I have been lucky enough to progress with some of my students from primary school to college age. I managed to continue my teaching career during lockdown, in which I taught lessons over zoom which was both enjoyable and kept me busy during the pandemic. I have also hosted concerts for my students at my home, which has included small orchestras of adults and children.
            </p>
            <p className="mt-4 text-base sm:text-lg md:text-xl leading-loose">
            My experience as an official accompanist at the Junior Department of the Guildhall School of Music and Drama fulfilled my passion for working with young people, which I now continue in my teaching career. I was also shortlisted for a post at the Yehudi Menuhin School in 2011. 
            </p>
            <p className="mt-4 text-base sm:text-lg md:text-xl leading-loose">
            In connection with my career in the film and TV industry, I have coached many actors including Judy Lowe, Sally Hawkins and Martin Freeman.
            </p>
          </div>
          
          {/* Right Column */}
          <div className="flex items-center justify-center">
            <div className="w-full md:w-4/5 lg:w-3/4 xl:w-2/3">
              <img 
                src={teachingImage} 
                alt="Sally teaching a student" 
                className="rounded-md shadow-lg" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Teaching;
